import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortDirection, TopDiscountSortEntity } from 'config';
import { ITopDiscountState } from './topDiscounts.types';

const initialState: ITopDiscountState = {
  discounts: undefined,
  isLoading: false,
  error: null,
  sortField: TopDiscountSortEntity.clicksCount,
  sortDirection: SortDirection.DESC,
};

export const topDiscountReducer = createSlice({
  name: 'topDiscounts',
  initialState,
  reducers: {
    setTopDiscountsLoading: (state) => {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    },
    setTopDiscountsSuccess: (state, action) => {
      return {
        ...state,
        discounts: action.payload,
        isLoading: false,
        error: null,
      };
    },
    setTopDiscountsError: (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },
    setSortField: (state, action) => {
      return {
        ...state,
        sortField: action.payload,
      };
    },

    setSortDirection: (state, action) => {
      return {
        ...state,
        sortDirection: action.payload,
      };
    },
  },
});

export const {
  setTopDiscountsLoading,
  setTopDiscountsSuccess,
  setTopDiscountsError,
  setSortField,
  setSortDirection,
} = topDiscountReducer.actions;

export default topDiscountReducer.reducer;
